export default __webpack_public_path__ + "static/media/Insight_data_tableau_récap_35.897bca3a.svg";